export const GET_TEAM_DATA_REQUEST = "GET_TEAM_DATA_REQUEST";
export const GET_TEAM_DATA_SUCCESS = "GET_TEAM_DATA_SUCCESS";
export const GET_TEAM_DATA_FAIL = "GET_TEAM_DATA_FAIL";

export const GET_COST_REPORT_REQUEST = 'app/TeamProgressContainer/GET_COST_REPORT_REQUEST';
export const GET_COST_REPORT_SUCCESS = 'app/TeamProgressContainer/GET_COST_REPORT_SUCCESS';
export const GET_COST_REPORT_FAIL = 'app/TeamProgressContainer/GET_COST_REPORT_FAIL';

export const GET_MONTHLY_REPORT_REQUEST = 'app/TeamProgressContainer/GET_MONTHLY_REPORT_REQUEST';
export const GET_MONTHLY_REPORT_SUCCESS = 'app/TeamProgressContainer/GET_MONTHLY_REPORT_SUCCESS';
export const GET_MONTHLY_REPORT_FAIL = 'app/TeamProgressContainer/GET_MONTHLY_REPORT_FAIL';